import React, { useState, useEffect } from 'react';
import { ChevronRight } from 'lucide-react';
import img1 from '../../assets/FRONT AREA 01.png';
import img2 from '../../assets/AERIAL.png';
import img3 from '../../assets/WELLNESS CENTER.png';

const HeroSlideshow = () => {
  const images = [img1, img2, img3];

  const [activeSlide, setActiveSlide] = useState(0);
  const [nextSlide, setNextSlide] = useState(1);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setActiveSlide(prev => (prev + 1) % images.length);
        setNextSlide(prev => (prev + 1) % images.length);
        setIsTransitioning(false);
      }, 800);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const handleSlideChange = (direction) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setTimeout(() => {
      if (direction === 'next') {
        setActiveSlide(prev => (prev + 1) % images.length);
        setNextSlide(prev => (prev + 1) % images.length);
      } else {
        setActiveSlide(prev => (prev - 1 + images.length) % images.length);
        setNextSlide(prev => (prev - 1 + images.length) % images.length);
      }
      setIsTransitioning(false);
    }, 800);
  };

  return (
    <div className="w-full h-[75svh] sm:h-[90svh] relative overflow-hidden bg-black">
      {/* Image Stack with Parallax */}
      <div className="absolute inset-0">
        {images.map((img, idx) => (
          <div
            key={idx}
            className="absolute inset-0 transition-all duration-1000 ease-out"
            style={{
              opacity: idx === activeSlide ? 1 : idx === nextSlide ? 0 : 0,
              transform: idx === activeSlide 
                ? 'scale(1) translateY(0)' 
                : idx === nextSlide 
                ? 'scale(1.08) translateY(30px)' 
                : 'scale(1) translateY(0)',
            }}
          >
            <img
              src={img}
              alt={`Slide ${idx + 1}`}
              className="w-full h-full object-cover"
            />
          </div>
        ))}
      </div>

      {/* Animated Slide Indicators */}
      <div className="absolute bottom-8 left-8 flex gap-3 z-20">
        {images.map((_, idx) => (
          <button
            key={idx}
            onClick={() => {
              if (isTransitioning) return;
              setIsTransitioning(true);
              setTimeout(() => {
                setActiveSlide(idx);
                setNextSlide((idx + 1) % images.length);
                setIsTransitioning(false);
              }, 800);
            }}
            className="group relative h-1.5 bg-white/25 hover:bg-white/50 transition-all duration-300 cursor-pointer"
            style={{ width: idx === activeSlide ? '40px' : '12px' }}
          >
            <div
              className="absolute inset-0 bg-white origin-left rounded-full"
              style={{
                animation: idx === activeSlide ? 'slideProgress 5s linear forwards' : 'none',
              }}
            />
          </button>
        ))}
      </div>

      {/* Main Content */}
      <div className="absolute inset-0 flex flex-col justify-start items-start pointer-events-none">
        <div className="w-full max-w-3xl px-5 sm:px-8 lg:px-16 py-5 sm:py-8 md:py-12">
          <div className="space-y-6">
            {/* Slide Counter with Accent Line */}
            {/* <div 
              className="flex items-center gap-4"
              style={{ animation: 'fadeInUp 0.8s ease-out 0.1s both' }}
            >
              <div className="text-[var(--primarycolor)] text-xs font-light tracking-[3px] uppercase">
                {String(activeSlide + 1).padStart(2, '0')} / {String(images.length).padStart(2, '0')}
              </div>
              <div className="h-px bg-gradient-to-r from-cyan-400/60 to-transparent flex-grow max-w-20" />
            </div> */}

            {/* Main Headline with Gradient */}
             <h1 
              className="text-2xl sm:text-3xl lg:text-5xl leading-[1.2] font-medium sm:font-normal max-w-[75%] sm:max-w-xl lg:max-w-2xl"
              style={{
                animation: 'slideInLeft 0.8s ease-out 0.2s both',
                letterSpacing: '0.01em',
                color: 'var(--primarycolor)',
                // fontWeight: '500'
              }}
            >
              Where Dignity, Comfort, and Care Come Together
            </h1>

            {/* CTA Button */}
            {/* <div style={{ animation: 'slideInLeft 0.8s ease-out 0.4s both' }} className="pointer-events-auto">
              <button 
                className="group relative px-6 py-3 font-semibold text-sm sm:text-base rounded-full overflow-hidden backdrop-blur-md"
                style={{
                  background: 'var(--primarycolor)',
                  color: 'white',
                }}
              >
                <span className="relative z-10 flex items-center justify-center gap-2">
                  Discover More
                  <ChevronRight className="w-4 h-4 transition-all group-hover:translate-x-1 duration-300" />
                </span>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-500" />
              </button>
            </div> */}
          </div>
        </div>
      </div>

      {/* Navigation Arrows */}
      <div className="absolute right-8 bottom-8 sm:right-16 sm:bottom-16 flex gap-3 z-20 pointer-events-auto">
        <button
          onClick={() => handleSlideChange('prev')}
          disabled={isTransitioning}
          className="p-3 rounded-full border border-white/40 text-white/70 hover:text-white hover:bg-white/10 hover:border-white/70 transition-all duration-300 backdrop-blur-md disabled:opacity-50 disabled:cursor-not-allowed group"
        >
          <ChevronRight className="w-5 h-5 rotate-180 group-hover:-translate-x-1 transition-transform" />
        </button>
        <button
          onClick={() => handleSlideChange('next')}
          disabled={isTransitioning}
          className="p-3 rounded-full border border-white/40 text-white/70 hover:text-white hover:bg-white/10 hover:border-white/70 transition-all duration-300 backdrop-blur-md disabled:opacity-50 disabled:cursor-not-allowed group"
        >
          <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
        </button>
      </div>

      {/* CSS Animations */}
      <style>{`
        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-60px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes expandWidth {
          from {
            width: 0;
            opacity: 0;
          }
          to {
            width: 100%;
            opacity: 1;
          }
        }

        @keyframes slideProgress {
          from {
            width: 100%;
          }
          to {
            width: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default HeroSlideshow;